import {
    Main,
    SchedulerOverview,
    CreateSchedulerRule,
    TemplatesOverview,
    CreativeMappings,
    MaterialSpecs,
    BriefingForm,
    Unauthorized,
} from "pages";

export const pathKey = {
    MAIN: "main",
    SCHEDULER_OVERVIEW: "schedulerOverview",
    CREATE_SCHEDULER_CONFIG: "createSchedulerConfig",
    TEMPLATES_OVERVIEW: "templatesOverview",
    CREATIVE_MAPPINGS_OVERVIEW: "creativesMappingsOverview",
    CAMPAIGN: "campaign",
    BRIEFING_FORM: "briefingForm",
    FORM_TEST: "formTest",
    UNAUTHORIZED: "unauthorized",
};

export const pathName = {
    MAIN: "/",
    PAGE_NOT_FOUND: "/page-not-found",
    CREATIVE_MAPPINGS_OVERVIEW: "/creative-mappings",
    SCHEDULER_OVERVIEW: "/rules",
    CREATE_SCHEDULER_CONFIG: "/rules/create",
    TEMPLATES_OVERVIEW: "/templates",
    CREATE_TEMPLATE: "/templates/create",
    TEMPLATES_EDITOR: "/templates/:name",
    CAMPAIGN: "/campaign",
    BRIEFING_FORM: "/briefing-form/:materialSpecificationId",
    UNAUTHORIZED: "/unauthorized",
};

export const routes = [
    {
        key: pathKey.MAIN,
        exact: true,
        path: pathName.MAIN,
        component: Main,
    },
    {
        key: pathKey.SCHEDULER_OVERVIEW,
        exact: true,
        path: pathName.SCHEDULER_OVERVIEW,
        component: SchedulerOverview,
    },
    {
        key: pathKey.CREATE_SCHEDULER_CONFIG,
        exact: true,
        path: pathName.CREATE_SCHEDULER_CONFIG,
        component: CreateSchedulerRule,
    },
    {
        key: pathKey.TEMPLATES_OVERVIEW,
        exact: true,
        path: pathName.TEMPLATES_OVERVIEW,
        component: TemplatesOverview,
    },
    {
        key: pathKey.CREATIVE_MAPPINGS_OVERVIEW,
        exact: true,
        path: pathName.CREATIVE_MAPPINGS_OVERVIEW,
        component: CreativeMappings,
    },
    {
        key: pathKey.CAMPAIGN,
        exact: true,
        path: pathName.CAMPAIGN,
        component: MaterialSpecs,
    },
    {
        key: pathKey.BRIEFING_FORM,
        exact: true,
        path: pathName.BRIEFING_FORM,
        component: BriefingForm,
    },
    {
        key: pathKey.UNAUTHORIZED,
        exact: true,
        path: pathName.UNAUTHORIZED,
        component: Unauthorized,
    },
];
